import { render, staticRenderFns } from "./result_panel.vue?vue&type=template&id=287d71f0&scoped=true&"
import script from "./result_panel.vue?vue&type=script&lang=ts&"
export * from "./result_panel.vue?vue&type=script&lang=ts&"
import style0 from "./result_panel.vue?vue&type=style&index=0&id=287d71f0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d71f0",
  null
  
)

export default component.exports